import { darken } from 'polished';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';

import { IconLoyaltyPoints } from 'components/icons/loyalty-points-icon';
import { Modal } from 'components/modal';

import { theme } from './theme';

type StoreHourContainerProps = {
  isToday: boolean;
};

export const Background = styled.div`
  background: ${theme.modalBackground};
  width: 100%;
`;

export const Inner = styled.div`
  margin: 0 auto;
  background: ${theme.modalBackground};
  color: ${theme.innerColor};
  padding-block-start: 20px;

  > * {
    width: 100%;
    display: block;
  }

  h2 {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.base};
    margin: 0;
    text-transform: capitalize;
  }

  a {
    color: ${theme.innerAnchorColor};
    font-weight: 500;
    font-size: 0.875rem;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const Address = styled.div`
  font-size: 0.9375rem;
  color: ${theme.addressColor};
  text-transform: capitalize;
  line-height: 1.4;
`;

export const PhoneNumber = styled(Link)`
  color: ${theme.phoneNumberColor};
  line-height: 1.4;
  font-size: 0.9375rem;
`;

export const Amenity = styled.div`
  margin-block-end: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
`;

export const WaysToOrder = styled.div`
  display: grid;

  ${Styles.desktop} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const SectionSubtitle = styled.h3`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  margin-block-start: 0;
  margin-block-end: 14px;
  margin-inline: 0;
  text-transform: capitalize;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SpacingLine = styled.div<{ bottom: number; top: number }>`
  border-block-start: 1px solid rgba(177, 177, 177, 0.7);
  margin-block-start: ${p => p.top}px;
  margin-block-end: ${p => p.bottom}px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  inset-block-end: 0;
  border-block-start: 1px solid rgba(177, 177, 177, 0.7);
  width: 100%;
  height: 81px;
  display: flex;
  align-items: center;
  background: ${theme.modalBackground};

  ${Styles.native(css`
    /* using the full safe-area inset makes this component too tall */
    padding-block-end: calc(env(safe-area-inset-bottom) / 2);
  `)}
`;

export const StoreHourContainer = styled.div<StoreHourContainerProps>`
  margin: 0.25rem 0;
  display: flex;
  padding: 0.5rem 0;

  ${({ isToday }) =>
    isToday &&
    css`
      background-color: ${darken(0.05, Styles.color.background)};
    `}
  ${Styles.desktop} {
    max-width: 533px;
    width: 90%;
    margin: 0 auto;
  }
`;

const CenterContainerStyle = css`
  max-width: 485px;
  width: 90%;
  margin: 0 auto;
`;

export const StoreHourWrapper = styled.div`
  ${CenterContainerStyle};
  display: flex;
`;

export const WeekDayWrapper = styled.div`
  flex: 1;
  margin-inline-end: 8px;
`;

export const HoursOfOperationWrapper = styled.div`
  text-align: end;
`;

export const StoreStatusWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const InnerContentWrapper = styled.div`
  ${CenterContainerStyle};
`;

export const HoursTitle = styled(SectionSubtitle)`
  ${CenterContainerStyle};
`;

export const DayWeek = styled.div`
  display: inline-block;
`;

export const AddressAndPhone = styled.div`
  * {
    font-size: 1rem !important;
    line-height: 1.5;
  }

  a:first-of-type {
    font-weight: bold;
  }
`;

export const StoreModal = styled(Modal)`
  ${Styles.desktop} {
    &&& {
      width: ${Styles.layout.smallerSectionMaxWidth};
    }
  }
`;

export const FeatureIcon = styled.img`
  height: 1.5em;
  width: 1.9em;
`;

export const LoyaltyTagsContainer = styled.div`
  display: flex;
`;

export const LoyaltyTag = styled.div`
  display: flex;
  line-height: 1.25rem;
  background: ${Styles.color.cardBackground};
  padding: 0.2rem 0.7rem;
  margin-block: 0.5rem;
  margin-inline-start: 0;
  margin-inline-end: 0.5rem;
  font-size: 0.8rem;
  border-radius: 0.4rem;
`;

export const StyledLoyaltyIcon = styled(IconLoyaltyPoints)`
  margin-inline-end: 0.5rem;
`;

export const PrefixSpan = styled.span`
  color: ${Styles.color.grey.one};
  margin: 0 8px;
`;
